import ScrollTop from "./ScrollTop";
import VisualSlide from "./VisualSlide";
import News from "./News";
import MainSlider from "./MainSlider";
import Case from "./Case";
import Client from "./Client";
import Slogan from "./Slogan";
import MainBanner from "./MainBanner";
import Popup from "./Popup";

// css
import "../css/MainPage.css";

function MainPage() {
  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "@id": "https://rbrain.co.kr/#webpage",
        url: "https://rbrain.co.kr",
        name: "생성형 AI · RAG · RPA 기반 지능형 업무자동화 전문기업 | 레인보우브레인 Rainbow Brain",
        description:
          "레인보우브레인은 생성형 AI, RAG, RPA 기술을 기반으로 문서 자동화, 지식 검색, 스마트 리포팅 등 지능형 업무 자동화를 제공하는 전문 기업입니다.",
        isPartOf: { "@id": "https://rbrain.co.kr/#website" },
        inLanguage: "ko-KR",
      },
      {
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "홈",
            item: "https://rbrain.co.kr",
          },
        ],
      },
    ],
  };

  return (
    <>
      <ScrollTop />
      <Popup />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />

      <h1>생성형 AI · RAG · RPA 기반 지능형 업무 자동화 전문기업</h1>

      <VisualSlide />

      <News />
      <MainSlider />
      <Case />
      <Client />

      {/* <CustomerCase /> */}

      <Slogan />
      <MainBanner />
    </>
  );
}

export default MainPage;
